// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("./Utils.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AvatarDefaultSvg = require("../../assets/images/elements/avatar-default.svg");

var _placeholder = AvatarDefaultSvg;

function from_key(widthOpt, heightOpt, key) {
  var width = widthOpt !== undefined ? widthOpt : 60;
  var height = heightOpt !== undefined ? heightOpt : 60;
  return Core__Option.getOr(Core__Option.map(key, (function (v) {
                    return Utils.makeAttachmentUrl(width, height, true, undefined, undefined, undefined, v);
                  })), _placeholder);
}

var place_holder = from_key(undefined, undefined, undefined);

var placeholder = place_holder;

exports.from_key = from_key;
exports.place_holder = place_holder;
exports.placeholder = placeholder;
/* _placeholder Not a pure module */
